module.exports = __webpack_public_path__ + "static/img/gongke.0d0522d3.png";